var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "mode new_mode",
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "custom-class": "layout-dialog",
        title: "商品明細選択",
        top: "5vh",
        visible: _vm.dialogVisible,
        "show-close": false,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        opened: _vm.opened,
        close: _vm.overrideClose,
      },
    },
    [
      _c(
        "vab-query-form-mode",
        {
          staticClass: "dpform noborder nopadding",
          attrs: {
            model: _vm.queryForm,
            rules: _vm.rules,
            "enable-query-save": false,
            size: "mini",
            "label-position": "left",
            "label-width": "98px",
          },
          on: { search: _vm.onSearch },
        },
        [
          _c(
            "el-row",
            { staticClass: "row_mb27", attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("vab-input", {
                    attrs: {
                      prop: "itmdtlcd",
                      label: "商品明細CD",
                      maxlength: "3",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("vab-input", {
                    staticClass: "mb16",
                    attrs: {
                      prop: "itmdtlnmk",
                      label: "商品明細名",
                      maxlength: "50",
                      "show-after": "半角ｶﾅ",
                      validate: "halfKana",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "mt16 nomargin_w" },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("vab-table", {
                ref: "table",
                attrs: {
                  "api-url": _vm.apiJudge
                    ? "/api/mitmdtlp/queryItemDetail"
                    : "/api/mitmdtlp/queryItemDetailGroup",
                  columns: _vm.columns,
                  "custom-config": false,
                  "multi-select": _vm.multiSelect,
                  "query-params": Object.assign({}, _vm.queryForm, {
                    sidx: "itmdtlcd",
                    sort: "asc",
                  }),
                  "init-params": Object.assign({}, _vm.queryForm, {
                    sidx: "itmdtlcd",
                    sort: "asc",
                  }),
                  "primary-key": "itmdtlcd",
                  "primary-key-sort": "asc",
                  "row-key": _vm.getRowKey,
                  "enable-init": false,
                },
                on: { "selection-change": _vm.setSelectRows },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer flex_end",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "flex_start flex_center_align" },
            [
              _c(
                "el-button",
                { staticClass: "cancel", on: { click: _vm.overrideClose } },
                [_vm._v("キャンセル")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "sub_btn select_btn",
                  attrs: {
                    type: "primary",
                    disabled: _vm.selectRows.length == 0,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [
                  _c("svg-icon", {
                    staticClass: "sub_btn_svg",
                    class:
                      _vm.selectRows.length == 0 ? "answer_disabled" : "answer",
                    attrs: { "icon-class": "check_line" },
                  }),
                  _vm._v(" 確定 "),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }